import { createSlice } from "@reduxjs/toolkit";

export const CustomerSlice = createSlice({
    name: "customerSlice",
    initialState: {
        allCustomer: [],
        allCustomerWithPagination: {
            total_page_count: 1,
            data: []
        }
    },
    reducers: {
        getAllCustomerReducer: (state, action) => {
            state.allCustomer = action.payload
        },
        // get all custotmer with pagination reducer
        getAllCustomerWithPaginationReducer: (state, action) => {
            state.allCustomerWithPagination = {
                total_page_count: action?.payload.total_page_count || 1,
                data: action?.payload?.data
            }
        }
    }
})